
/**
 * @param {object} payload
 * @param {string} payload.message
 * @param {boolean} payload.sendSms
 * @param {boolean} payload.sendPushNotification
 * @return {object}
 */
export function extractMessageData ({ message, sendSms, sendPushNotification }) {
  return { message, sendSms, sendPushNotification };
}



// WEBPACK FOOTER //
// ./src/helpers/messages.js